import { Tabs } from "antd";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import QuizAutoPickQuestions from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizAutoPickQuestions";
import QuizCreation from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizCreation";
import QuizManualPickQuestions from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/QuizManualPickQuestions";
import { useEffect } from "react";

const QuizBuilderTabs = () => {
  const { active, setActive, generatedQuestion, setMaxQuestionLimit, limit } =
    useQuizContext();
  const { quizQueLim: MAXIMUM_QUESTION_COUNT } = limit || {};
  const {
    alreadySelected = [],
    autoPick = [],
    manualPick = [],
  } = generatedQuestion || {};
  const totalQuestions =
    alreadySelected.length + manualPick.length + autoPick.length;
  useEffect(() => {
    setMaxQuestionLimit(totalQuestions);
  }, [totalQuestions]);
  return (
    <Tabs
      activeKey={active}
      defaultActiveKey={active}
      onChange={(index: string) => {
        setActive(index);
      }}
      tabBarExtraContent={
        <div>
          <span
            style={{
              color: "black",
              fontWeight: 600,
              marginRight: "8px",
            }}
          >
            Questions Selected:
          </span>
          <span>
            {totalQuestions}/{MAXIMUM_QUESTION_COUNT}
          </span>
        </div>
      }
      items={[
        {
          key: "1",
          label: `Generate Random ${
            autoPick.length ? `(${autoPick.length})` : ""
          }`,
          children: <QuizAutoPickQuestions></QuizAutoPickQuestions>,
        },
        {
          key: "2",
          label: `Select Manually ${
            manualPick.length ? `(${manualPick.length})` : ""
          }`,
          children: <QuizManualPickQuestions></QuizManualPickQuestions>,
        },
        {
          key: "3",
          label: `Quiz Builder ${
            totalQuestions
              ? `(${totalQuestions}/${MAXIMUM_QUESTION_COUNT})`
              : ""
          }`,
          children: <QuizCreation></QuizCreation>,
        },
      ]}
    />
  );
};

export default QuizBuilderTabs;
